export default __webpack_public_path__ + "49b2c23db70e97fcbdfe4bfe014389eb.png";